<template>
        <router-link v-if="originalValue == null" :to="customerReference" class="d-flex justify-center align-center pa-0 fill-height">
            <v-icon v-if="originalValue == null" color="primary" :icon="mdiCogOutline" class="cursor-pointer" size="x-large"/>
        </router-link>
        <span v-else>{{ originalValue }}</span>
</template>

<script setup>
import { onBeforeMount, ref } from 'vue';
import { mdiCogOutline } from '@mdi/js';

const props = defineProps(['params']);

const originalValue = ref(null);
const customerReference = ref('/Customers/');

onBeforeMount(() => {
if (!props.params.node.group && props.params.colDef.field == 'manage' && props.params.node.rowPinned != 'bottom')
    customerReference.value += props.params.node.data.reference;

// ROW PINNED BOTTOM
else
    originalValue.value = '';
});

</script>
